export default {
  inputRules: {
    required: 'Ce champs est requis.',
    username: "Ce nom d'/utilisateur n'est pas disponible",
    user_email: 'Ce courriel est déjà utilisé.',
    user_name: `Ce Login n'est pas disponible.`,
    congeVac: 'Une demande de congé existe déjà pour cette date'
  }
};
